import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { URL_BFM_BOOKING_AVAILABILITY_SEARCH, URL_BFM_BOOKING_AVAILABILITY_SEARCH_MULTICITY, MOCK_URL_AVAILABILITY_BOOKING_SEARCH, MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_BOTH, MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_OUTBOUND, MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_INBOUND, MOCK_URL_AVAILABILITY_BOOKING_SEARCH_MULTICITY, MOCK_STATUS, MOCK_URL_AVAILABILITY_BOOKING_SEARCH_211, MOCK_URL_AVAILABILITY_BOOKING_SEARCH_PAY_WITH_MILES, URL_BFM_BOOKING_AVAILABILITY_MULTICITY_PAGINATION, URL_BFM_BOOKING_AVAILABILITY_MULTICITY_SORT_BY, MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STAR_ALLIANCE, URL_BFM_BOOKING_AVAILABILITY_MULTICITY_FILTER_BY, URL_BFM_BOOKING_AVAILABILITY_FLEX_PRICER, URL_BFM_BOOKING_AVAILABILITY_RETRIEVE_MATRIX, MOCK_URL_BOOKING_AVAILABILITY_RETRIEVE_MATRIX } from '@ibe.config';
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
import * as i2 from "@angular/common/http";
var INDRABookingAvailabilityService = /** @class */ (function () {
    function INDRABookingAvailabilityService(api, http) {
        this.api = api;
        this.http = http;
    }
    INDRABookingAvailabilityService.prototype.INDRA_searchBookingAvailability = function (param) {
        if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH) {
            var mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH;
            if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH_211) {
                mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_211;
            }
            else {
                if (param['payWithMiles'] == true && param['starAlliance'] == false) {
                    mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_PAY_WITH_MILES;
                }
                else if (param['payWithMiles'] == true && param['starAlliance'] == true) {
                    mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STAR_ALLIANCE;
                }
                else if (param['stopOverOutboundLocation'] && param['stopOverInboundLocation']) {
                    mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_BOTH;
                }
                else if (param['stopOverOutboundLocation']) {
                    mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_OUTBOUND;
                }
                else if (param['stopOverInboundLocation']) {
                    mockURL = MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_INBOUND;
                }
            }
            return this.http.get(mockURL);
        }
        else {
            if (param.payWithMiles) {
                return this.api.INDRA_post(URL_BFM_BOOKING_AVAILABILITY_SEARCH + "?payWithMiles=" + param.payWithMiles + "&starAlliance=" + param.starAlliance, param);
            }
            else {
                return this.api.INDRA_post(URL_BFM_BOOKING_AVAILABILITY_SEARCH + "?payWithMiles=false&starAlliance=false", param);
            }
        }
    };
    INDRABookingAvailabilityService.prototype.INDRA_searchBookingAvailabilityForMulticity = function (param) {
        // use mock for stopover-waitlist avalability
        // return this.http.get<any>(MOCK_URL_AVAILABILITY_BOOKING_SEARCH_STOPOVER_WAITLIST);
        if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH_MULTICITY) {
            return this.http.get(MOCK_URL_AVAILABILITY_BOOKING_SEARCH_MULTICITY);
        }
        else {
            return this.api.INDRA_post(URL_BFM_BOOKING_AVAILABILITY_SEARCH_MULTICITY, param);
        }
    };
    INDRABookingAvailabilityService.prototype.INDRA_searchPaginationForMulticity = function (param) {
        if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH_MULTICITY) {
            return this.http.get(MOCK_URL_AVAILABILITY_BOOKING_SEARCH_MULTICITY);
        }
        else {
            return this.api.INDRA_get(URL_BFM_BOOKING_AVAILABILITY_MULTICITY_PAGINATION + "?first=" + param.first + "&last=" + param.last);
        }
    };
    INDRABookingAvailabilityService.prototype.INDRA_searchSortByForMulticity = function (param) {
        if (MOCK_STATUS.BOOKING_AVAILABILITY_SEARCH_MULTICITY) {
            return this.http.get(MOCK_URL_AVAILABILITY_BOOKING_SEARCH_MULTICITY);
        }
        else {
            return this.api.INDRA_get(URL_BFM_BOOKING_AVAILABILITY_MULTICITY_SORT_BY + "?first=" + param.first + "&last=" + param.last + "&sortBy=" + param.sortBy);
        }
    };
    INDRABookingAvailabilityService.prototype.INDRA_searchFilteredBookingAvailabilityForMulticity = function (searchParam, param) {
        // to do... mock data
        var concatURL = URL_BFM_BOOKING_AVAILABILITY_MULTICITY_FILTER_BY + "?first=" + param.first + "&last=" + param.last;
        return this.api.INDRA_post(concatURL, searchParam);
        // return this.api.INDRA_post<any>(URL_BFM_BOOKING_AVAILABILITY_MULTICITY_FILTER_BY, searchParam);
    };
    INDRABookingAvailabilityService.prototype.INDRA_searchFlexPricerPremiumFlights = function (param) {
        return this.api.INDRA_post(URL_BFM_BOOKING_AVAILABILITY_FLEX_PRICER, param);
    };
    INDRABookingAvailabilityService.prototype.INDRA_retrieveMatrix = function () {
        if (MOCK_STATUS.BOOKING_AVAILABILITY_MATRIX_PANEL) {
            return this.http.get(MOCK_URL_BOOKING_AVAILABILITY_RETRIEVE_MATRIX);
        }
        else {
            return this.api.INDRA_post(URL_BFM_BOOKING_AVAILABILITY_RETRIEVE_MATRIX, null);
        }
    };
    INDRABookingAvailabilityService.ngInjectableDef = i0.defineInjectable({ factory: function INDRABookingAvailabilityService_Factory() { return new INDRABookingAvailabilityService(i0.inject(i1.INDRAApiService), i0.inject(i2.HttpClient)); }, token: INDRABookingAvailabilityService, providedIn: "root" });
    return INDRABookingAvailabilityService;
}());
export { INDRABookingAvailabilityService };
